import axios from 'axios';

const LOCAL_API = 'http://localhost:5000/api';
const PROD_API = process.env.REACT_APP_API_URL || 'https://your-production-backend.com/api';

const BASE_URL = process.env.NODE_ENV === 'development' ? LOCAL_API : PROD_API;

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  
  const tenantId = localStorage.getItem('selectedTenantId');
  if (tenantId) config.headers['x-tenant-id'] = tenantId;

  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED') {
      console.error('Request timeout');
    }
    return Promise.reject(error);
  }
);

export default API;